import { FoquzComponent } from "Models/foquz-component";
import { startPoll, stopPoll } from "@/api/poll/publish-poll";
import { PollActivateEvent, PollPublishEvent } from "@/utils/events/poll";
export class ViewModel extends FoquzComponent {
  constructor(params, element) {
    super(params);

    this.poll = params.poll;
    this.id = this.poll.id;

    this.disableFetch = ko.observable(false)

    this.isNew = ko.observable(this.poll.isNew);
    this.isPublished = ko.observable(this.poll.is_published);
    this.isActive = ko.observable(this.poll.isActive);

    if (this.isNew()) {
      PollActivateEvent.once((params) => {
        if (params.id == this.id) this.isNew(false);
      });
    }

    this.canStartStopPolls = window.CURRENT_USER.can_start_stop_polls === 0;

    this.isActiveName = ko.computed(() => {
      const value = this.isActive() ? 'Активный' : 'Неактивный';
      return value;
    });

    this.isDisabled = ko.computed(() => {
      return window.CURRENT_USER.watcher || window.CURRENT_USER.filial_employee || this.canStartStopPolls || this.disableFetch() || this.isNew();
    });

    let isProcessing = false;

    this.isActive.subscribe((newValue) => {
      const shouldDisableControl = window.CURRENT_USER.watcher || this.isNew();
      if (isProcessing || shouldDisableControl) return;
      isProcessing = true;
      if (newValue) {
        this.start().finally(() => {
          isProcessing = false;
        });
      } else {
        this.stop().finally(() => {
          isProcessing = false;
        });
      }
    });
  }

  async stop() {
    try {
      this.disableFetch(true)
      await stopPoll(this.id);
      this.isActive(false);
      PollActivateEvent.emit({ id: this.id, isActive: false });
    } catch (error) {
      console.error('Failed to stop poll:', error);
      this.isActive(true);
    }
    finally {
      this.disableFetch(false)
    }
  }

  async start() {
    try {
      this.disableFetch(true)
      await startPoll(this.id);
      this.isActive(true);
      PollActivateEvent.emit({ id: this.id, isActive: true });
    } catch (error) {
      console.error('Failed to start poll:', error);
      this.isActive(false);
    }
    finally {
      this.disableFetch(false)
    }
  }
}
